import { render, staticRenderFns } from "./ManagementGuideContent.vue?vue&type=template&id=0386e50e&scoped=true&"
import script from "./ManagementGuideContent.vue?vue&type=script&lang=js&"
export * from "./ManagementGuideContent.vue?vue&type=script&lang=js&"
import style0 from "./ManagementGuideContent.vue?vue&type=style&index=0&id=0386e50e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0386e50e",
  null
  
)

export default component.exports